export function parseContractError(err) {
  if (err.code === 4001 || err.code === 'ACTION_REJECTED') return '서명이 취소되었습니다.';
  const reason = err.reason
    || err?.info?.error?.message
    || err?.data?.message
    || '';
  if (reason.includes('Not the owner'))          return '관리자 계정으로 연결해 주세요.';
  if (reason.includes('Already voted'))          return '이미 투표하셨습니다.';
  if (reason.includes('Voting not active'))      return '현재 투표가 진행 중이 아닙니다.';
  if (reason.includes('Invalid election state')) return '현재 투표 상태에서 지원되지 않는 작업입니다.';
  if (reason.includes('Need at least 2'))        return '후보자가 2명 이상 필요합니다.';
  if (reason.includes('Name must be'))           return '이름은 1~30자여야 합니다.';
  if (reason.includes('Invalid candidate ID'))   return '유효하지 않은 후보자입니다.';
  return null;
}
